<template>
  <div class="modal-dim on my-barcode-modal">
    <div class="modal-wrap">
      <div class="modal-inner center my-barcode-modal__inner">
        <section
          class="my-barcode-modal__panel"
          role="dialog"
          aria-modal="true"
          aria-labelledby="my-barcode-modal-title"
          @keydown.esc="closeModal"
        >
          <header class="my-barcode-modal__header">
            <h1 id="my-barcode-modal-title">회원 바코드</h1>
            <button
              ref="closeButton"
              type="button"
              class="my-barcode-modal__close"
              aria-label="회원 바코드 닫기"
              @click="closeModal"
            >
              <span aria-hidden="true">×</span>
            </button>
          </header>

          <div class="my-barcode-modal__content">
            <p class="my-barcode-modal__guide">매장에서 회원 바코드를 보여주세요</p>
            <MyBarcodeDisplay :value="barcodeValue" />
            <p class="my-barcode-modal__number-label">바코드 번호</p>
            <strong class="my-barcode-modal__number">{{ barcodeValue }}</strong>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, nextTick, onMounted, ref } from 'vue';
import MyBarcodeDisplay from './MyBarcodeDisplay.vue';

const props = defineProps({
  data: {
    type: Object,
    default: () => ({})
  },
  index: {
    type: Number,
    default: 0
  }
});

const emit = defineEmits(['close']);
const closeButton = ref(null);
const barcodeValue = computed(() => String(props.data.value ?? ''));

const closeModal = () => emit('close', props.index);

onMounted(() => {
  nextTick(() => closeButton.value?.focus());
});
</script>

<style scoped>
.my-barcode-modal,
.my-barcode-modal * {
  box-sizing: border-box;
}

.my-barcode-modal__inner {
  width: 100%;
  padding: 16px;
}

.my-barcode-modal__panel {
  display: flex;
  width: min(100%, 440px);
  min-width: 0;
  max-height: calc(100vh - 32px);
  max-height: calc(100dvh - 32px);
  overflow: hidden auto;
  flex-direction: column;
  color: #263746;
  background: #ffffff;
  border: 1px solid #e6e8eb;
  border-radius: 12px;
}

.my-barcode-modal__header {
  display: flex;
  min-height: 64px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: space-between;
  padding: 14px 14px 14px 20px;
  gap: 16px;
  border-bottom: 1px solid #eef1f3;
}

.my-barcode-modal__header h1 {
  min-width: 0;
  margin: 0;
  font-size: 17px;
  font-weight: 700;
  line-height: 1.35;
}

.my-barcode-modal__close {
  display: inline-grid;
  width: 36px;
  height: 36px;
  flex: 0 0 36px;
  margin: 0;
  padding: 0;
  color: #5f6973;
  font: inherit;
  background: #ffffff;
  border: 1px solid #e4e8eb;
  border-radius: 50%;
  cursor: pointer;
  appearance: none;
  place-items: center;
  -webkit-tap-highlight-color: transparent;
}

.my-barcode-modal__close span {
  font-size: 25px;
  font-weight: 300;
  line-height: 1;
  transform: translateY(-1px);
}

.my-barcode-modal__close:focus-visible {
  outline: 3px solid rgba(72, 164, 213, 0.35);
  outline-offset: 2px;
}

.my-barcode-modal__content {
  display: flex;
  min-width: 0;
  align-items: center;
  padding: 24px 20px 28px;
  flex-direction: column;
}

.my-barcode-modal__guide {
  margin: 0 0 18px;
  color: #34424b;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.45;
  text-align: center;
  word-break: keep-all;
}

.my-barcode-modal__number-label {
  margin: 18px 0 4px;
  color: #71808d;
  font-size: 12px;
  line-height: 1.4;
}

.my-barcode-modal__number {
  max-width: 100%;
  color: #17212b;
  font-size: 18px;
  font-variant-numeric: tabular-nums;
  font-weight: 700;
  letter-spacing: 0.12em;
  line-height: 1.4;
  overflow-wrap: anywhere;
  text-align: center;
}

@media (hover: hover) {
  .my-barcode-modal__close:hover {
    background: #f8f9fa;
    border-color: #cfd6dc;
  }
}

@media (max-width: 359px) {
  .my-barcode-modal__inner {
    padding: 10px;
  }

  .my-barcode-modal__panel {
    max-height: calc(100vh - 20px);
    max-height: calc(100dvh - 20px);
  }

  .my-barcode-modal__header {
    padding-left: 16px;
  }

  .my-barcode-modal__content {
    padding: 20px 14px 24px;
  }
}
</style>
